import {
  FirestoreOrganisationMarketplace,
  FirestoreOrganisationSettings,
} from "reedy-data/api";
import { routePath } from "./RoutePath";

export const CODES_KINDS = ["THEMA", "BISAC"] as const;
export type CodesKind = (typeof CODES_KINDS)[number];

export const CODES_KIND_PARAM = "kind";

export const codesPath = (kind: CodesKind, query?: string) => {
  const path = `${routePath("/codes")}?${CODES_KIND_PARAM}=${kind}`;
  return query ? `${path}&q=${encodeURIComponent(query)}` : path;
};

export const parseCodesKind = (value: string | null) =>
  CODES_KINDS.find((kind) => kind === value);

export const getDefaultCodesKind = (
  settings: FirestoreOrganisationSettings = {},
): CodesKind =>
  settings.marketplace === FirestoreOrganisationMarketplace.US
    ? "BISAC"
    : "THEMA";
